(function () {
  const videoWrappers = document.querySelectorAll(".observed-video__wrapper");
  if (!videoWrappers.length) {
    // console.log('no video!');
    return;
  }
  
  const playVideoObserver = new IntersectionObserver(handlePlayVideo, {
    threshold: [0, 0.15, 1],
  });
  
  videoWrappers.forEach((wrapper) => playVideoObserver.observe(wrapper));

  function handlePlayVideo(entries) {
    entries.forEach(playVideo);
  }

  function playVideo(entry) {
    const video = entry.target.firstElementChild;
    if (entry.intersectionRatio === 1) {
      window.pauseAllMedia();
      video.play();
    } else if (entry.intersectionRatio < 0.1 && !video.paused) video.pause();
  }
})();
